var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reference-container"},[_c('div',{staticClass:"reference-text"},[_vm._v("Reference type :")]),_c('div',{staticClass:"reference-type-selected"},[_vm._v(" "+_vm._s(_vm.transferredReferenceType)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }